"use client";
import {
  Image_default
} from "./chunk-BVJ4WRGT.mjs";

// src/components/sections/AcceptedCardsList/AcceptedCardsList.tsx
import { forwardRef } from "react";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var defaultTitle = /* @__PURE__ */ jsxs(Fragment, { children: [
  "Aceite as principais formas de pagamento e",
  " ",
  /* @__PURE__ */ jsx("span", { className: "text-stone-500", children: "mais de 50 bandeiras" })
] });
var AcceptedCardsList = forwardRef(
  function AcceptedCardsList2({ title = defaultTitle, acceptedCardBrands, baseURL }, ref) {
    return /* @__PURE__ */ jsxs(
      "div",
      {
        className: "flex flex-col items-center justify-center bg-display-0",
        ref,
        children: [
          /* @__PURE__ */ jsx("h2", { className: "font-display text-gray-900 text-2xl md:text-xl lg:text-2xl font-bold leading-6 lg:leading-6 text-center", children: title }),
          /* @__PURE__ */ jsxs("div", { className: "flex flex-col justify-center items-center py-40 px-16 md:px-24 w-full md:max-w-[1195px]", children: [
            /* @__PURE__ */ jsx("div", { className: "flex gap-8 mt-24 w-[310px] sm:w-[630px] md:w-[734px] lg:w-full", children: /* @__PURE__ */ jsx(
              CardsBrandsSectionItem,
              {
                title: "Cr\xE9dito, d\xE9bito e outros",
                cardBrands: acceptedCardBrands.others,
                baseURL
              }
            ) }),
            /* @__PURE__ */ jsx("div", { className: "flex flex-col gap-8 lg:gap-40 justify-center w-[310px] sm:w-[630px] md:w-[681px] lg:w-full", children: /* @__PURE__ */ jsx(
              CardsBrandsSectionItem,
              {
                title: "Vouchers",
                cardBrands: acceptedCardBrands.vouchers,
                baseURL
              }
            ) })
          ] })
        ]
      }
    );
  }
);
var CardsBrandsSectionItem = ({
  title,
  cardBrands,
  baseURL
}) => {
  return /* @__PURE__ */ jsxs("div", { className: "mx-auto mb-16 !w-auto", children: [
    /* @__PURE__ */ jsx("div", { className: "flex flex-col items-center mt-[8px] whitespace-nowrap rounded-[1px] border border-b-0 border-display-300", children: /* @__PURE__ */ jsx("p", { className: "text-sm leading-1 mt-[-10px] px-4 font-sharon bg-display-0", children: title }) }),
    /* @__PURE__ */ jsx("div", { className: "flex flex-wrap gap-8 justify-center pt-4", children: cardBrands.map(({ name, description }) => /* @__PURE__ */ jsx(
      "div",
      {
        className: "relative !w-[45px] lg:!w-[56px] !h-[30px] lg:!h-[38px]",
        children: /* @__PURE__ */ jsx("div", { className: "relative w-full h-full", children: /* @__PURE__ */ jsx(
          Image_default,
          {
            src: `${baseURL}/${name}`,
            alt: description,
            layout: "fill"
          }
        ) })
      },
      description
    )) })
  ] });
};
var AcceptedCardsList_default = AcceptedCardsList;

export {
  AcceptedCardsList_default
};
